<div
  class="inline-multi-select"
  [ngClass]="{ 'inline-multi-select--disabled': !inlineMultiSelectInput.items.length }"
  (click)="presentPopover($event)"
>
  <div class="inline-multi-select__btn">
    <div>{{ inlineMultiSelectInput.displayName | translate }}</div>
    <div class="inline-multi-select__drop-down-chevron"></div>
  </div>
</div>
